import braintree from 'braintree-web';

const getConfig = (root, kind = 'config') => {
    const selector = `script[data-kind="${kind}"][type="application/json"]`;
    return [...root.querySelectorAll(selector)].map((script) => JSON.parse(script.textContent));
};

const paymentType = 'braintree:paypal';

Alpine.data('SevenBraintreePaypal', (element) => ({
    isSupported: false,
    instance: null,
    sdk: null,

    config: getConfig(element).at(-1),
    fundingSources: getConfig(element, 'funding-source'),

    // provided via model
    // @see https://braintree.github.io/braintree-web/3.34.0/PayPalCheckout.html#createPayment
    paymentOptions: {
        amount: 0,
    },

    init() {
        element.style.fontSize = '0';

        document.addEventListener('braintree:client:init', (event) => {
            const { client } = event.detail;

            braintree.paypalCheckout.create({
                client,
            }, (error, instance) => {
                if (error) {
                    this._dispatchEvent('error', { error });
                    return;
                }

                this.instance = instance;

                // @see https://developer.paypal.com/sdk/js/configuration
                instance.loadPayPalSDK({
                    'debug': false,
                    'intent': this.config.intent,
                    'locale': this.config.locale,
                    'currency': this.config.currency,
                    'buyer-country': this.config.country,
                    'integration-date': '2023-10-31',
                }, async (error, sdk) => {
                    if (error) {
                        this._dispatchEvent('error', { error });
                        return;
                    }

                    this.isSupported = true;
                    this.sdk = sdk;

                    await Promise.all(this.fundingSources.map(this._initFundingSource.bind(this)));
                });
            });
        });
    },

    async _initFundingSource(options) {
        const button = paypal.Buttons({
            ...options,
            onClick: this._onClick.bind(this),
            onApprove: this._onApprove.bind(this),
            createOrder: this._createOrder.bind(this),
            onInit: this._dispatchEvent.bind(this, 'init'),
            onCancel: this._dispatchEvent.bind(this, 'cancel'),
            onError: this._dispatchEvent.bind(this, 'error'),
        });

        if (button?.isEligible()) {
            button?.render(element);
        }
    },

    _onClick(detail, actions) {
        return new Promise((resolve) => {
            this._dispatchEvent('buttonclick', {
                ...detail,
                actions: {
                    resolve: () => resolve(actions.resolve()),
                    reject: () => resolve(actions.reject()),
                },
            });
        });
    },

    async _createOrder() {
        const pm = await new Promise((resolve) => {
            const payment = {
                flow: 'checkout',
                intent: this.config.intent,
                locale: this.config.locale,
                currency: this.config.currency,
                displayName: this.config.storeName,
                enableShippingAddress: false,
                shippingAddressEditable: false,
                ...(this.paymentOptions ?? {}),
            };

            if (this._dispatchEvent(`createpayment`, {
                payment,
                createPayment: (payment) => resolve(payment),
            })) {
                // event has not been cancelled, so we can resolve the promise automatically
                resolve(payment);
            }
        });

        const res = await this.instance.createPayment(pm);
        this._dispatchEvent(`paymentcreated`, { detail: res });
        return res;
    },

    async _onApprove(data, actions) {
        const payment = await this.instance.tokenizePayment(data);
        this._dispatchEvent('paymentauthorized', {
            ...payment,
            paymentToken: {
                type: paymentType,
                nonce: payment.nonce,
            },
        });
    },

    _dispatchEvent(name, { cancelable, bubbles, ...detail } = {}) {
        return element.dispatchEvent(new CustomEvent(`seven:braintree:paypal:${name}`, {
            detail,
            bubbles: bubbles ?? true,
            cancelable: cancelable ?? true,
        }));
    },

}));


